import { create } from "zustand";
import { getMe, type MeResponse } from "./api";

type User = NonNullable<MeResponse["user"]>;

interface SessionState {
  user: User | null;
  loading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
  reload: () => Promise<void>;
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  loading: true,
  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  clear: () => set({ user: null, loading: false }),
  reload: async () => {
    set({ loading: true });
    try {
      const res = await getMe();
      set({ user: res.user, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
}));
